import { Syllabus, Move, User } from "../../types";
import SyllabusService from "../../services/Syllabus";

import { QUERY_KEY } from "../studentProgress/useListStudentProgress";

import { makeQueryKey as makeFetchSyllabiQueryQuey } from "./useFetchSyllabus";
import useAuthorizedQuery from "../../common/hooks/useAuthorizedQuery";
import { compact } from "lodash";

export const makeQueryKey = (
  id?: Syllabus["id"],
  moveId?: Move["id"],
  userId?: User["id"]
) => [...makeFetchSyllabiQueryQuey(id), QUERY_KEY, moveId, userId];

function useFetchSyllabusStudentProgress(
  id?: Syllabus["id"],
  moveId?: Move["id"],
  userId?: User["id"]
) {
  const key = makeQueryKey(id, moveId);

  return useAuthorizedQuery(
    key,
    () => {
      if (id && moveId) {
        return SyllabusService.fetchSyllabusStudentProgress(id, moveId, userId);
      }

      throw new Error("Syllabus ID is required");
    },
    { enabled: !!id && !!moveId }
  );
}

export default useFetchSyllabusStudentProgress;
